import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DynamicTabSelector from "../components/DynamicTabSelector";
import TaskDetailTopBar from "../components/TaskDetailTopBar";
import TaskDetailContainer from "../components/TaskDetailContainer";
import TaskActionsContainer from "../components/TaskActionsContainer";
import TaskRecordsContainer from "../components/TaskRecordsContainer";
import { useTaskDetailForm } from "../hooks/useTaskDetailForm";

const TABS = ["Detail", "Actions", "Records"];

function TaskDetailScreen() {
  const { taskId } = useParams();
  const {
    taskDetail,
    taskName,
    taskDescription,
    handleNameChange,
    handleDescriptionChange,
    handleDeleteTask,
  } = useTaskDetailForm(taskId);
  const [selectedTab, setSelectedTab] = useState(0);

  if (!taskDetail) {
    return <div>Loading task details...</div>;
  }

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <TaskDetailContainer
            task={taskDetail}
            taskName={taskName}
            taskDescription={taskDescription}
            handleNameChange={handleNameChange}
            handleDescriptionChange={handleDescriptionChange}
            handleDeleteTask={handleDeleteTask}
          />
        );
      case 1:
        return <TaskActionsContainer task={taskDetail} />;
      case 2:
        return <TaskRecordsContainer task={taskDetail} />;
      default:
        return null;
    }
  };

  return (
    // Fill exactly the work area (viewport minus the 50px top bar and 60px
    // bottom bar) so the page itself never scrolls — only the content region
    // below the in-flow tab selector does.
    <div style={styles.screen}>
      <TaskDetailTopBar task={taskDetail} title={taskName} />
      <div style={styles.body}>
        {/* In-flow (non-floating) tab selector; it stays put while the content
            below scrolls. */}
        <DynamicTabSelector
          tabs={TABS}
          selectedTabIndex={selectedTab}
          onTabSelected={setSelectedTab}
          style={styles.tabSelector}
        />
        <div style={styles.scrollArea}>{renderContent()}</div>
      </div>
    </div>
  );
}

const styles = {
  screen: {
    paddingTop: "50px", // clear the fixed top bar
    height: "calc(100vh - 60px)", // viewport minus the fixed bottom bar
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
  body: {
    padding: "16px 16px 0",
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabSelector: {
    position: "relative",
    top: "auto",
    left: "auto",
    width: "auto",
    flexShrink: 0,
  },
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    marginTop: "16px",
    paddingBottom: "16px",
  },
};

export default TaskDetailScreen;
